import { atom } from "recoil";
export const transactions = atom({
  key: "transactions",
  default: [],
});
